export default import.meta.ROLLDOWN_FILE_URL_X8dM6mU7Vtv6fNQ4dYMp7A